// extracted by mini-css-extract-plugin
export var block = "messages-module--block--1Oj3c";
export var zzz = "messages-module--zzz--1m0fP";